import { render, staticRenderFns } from "./Newmail.vue?vue&type=template&id=ab7698dc&scoped=true&"
import script from "./Newmail.vue?vue&type=script&lang=js&"
export * from "./Newmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7698dc",
  null
  
)

export default component.exports